import PageCheckerList from './PageCheckerList';
import PageCheckerShow from './PageCheckerShow';
import CollectionsBookmarkIcon from '@material-ui/icons/CollectionsBookmark';

export default {
  list: PageCheckerList,
  show: PageCheckerShow,
  icon: CollectionsBookmarkIcon,
};
